import { addClass, removeClass } from "./functions";

/**
 * Burger Nav
 */
class burgerNav {
    _triggerNav             : HTMLInputElement;
    _mediaQuery             : any;
    _burgerNavEl            : HTMLElement;
    _body                   : HTMLElement;
    _navActiveClassName     : string;
    _navHiddenClassName     : string;
    _overflowHiddenClassName: string;
    _resizeTimeOut          : number;
    
    constructor(triggerSelector: HTMLInputElement, navContainerSelector: HTMLElement, mediaQuery?: any){
      this._triggerNav              = triggerSelector;
      this._mediaQuery              = mediaQuery;
      this._burgerNavEl             = navContainerSelector;
      this._body                    = document.querySelector("body");
      this._navActiveClassName      = 'nav-active' ;
      this._navHiddenClassName      = 'hidden';
      this._overflowHiddenClassName = 'overflow-hidden';
      this._resizeTimeOut           = 350;
    };

  init = () => {
    if(this._mediaQuery){
        if(this._mediaQuery.matches){
            this.addEvent();
        }
    }else {
        this.addEvent();
    }
    // Add window event listener for the resize
    this.windowEvent();
  }
  
  start = (e: Event) => { 
      /** @type {Boolean} */      
      let isChecked:boolean = (<HTMLInputElement>e.target).checked; 
      if (isChecked) {
        this.open();
        e.preventDefault();
      } else {
        this.close();
        this.hideNav();
        e.preventDefault();
      }
  }
  /**
   * Open 
   */
  open = () => {
      let selector = this._burgerNavEl;
      let navActiveClassName = this._navActiveClassName;

      removeClass({domElement: selector, classList: this._navHiddenClassName});
      setTimeout(function() {
        addClass({domElement: selector, classList: navActiveClassName});
      }, 5);
      addClass( {domElement: this._body, classList: this._overflowHiddenClassName} )
  }
  /**
   * Close
   */
  close = () => {
      removeClass({domElement: this._burgerNavEl, classList: this._navActiveClassName});      
      removeClass({domElement: this._body, classList: this._overflowHiddenClassName});      
  }
  /**
   * Close ended
  */
  hideNav = () => {
      let selector = this._burgerNavEl;
      let navHiddenClassName = this._navHiddenClassName;
      selector.addEventListener('transitionend', function() {
          addClass({domElement: selector, classList: navHiddenClassName});
      }, {
          capture: false,
          once: true,
          passive: false
      }); 
  }

  /**
   * Attach event 
   */
  addEvent = () => {
    this._triggerNav.addEventListener('change', this.start);
  }

  /**
   * Attach event 
   */
  removeEvent = () => {
    this._triggerNav.removeEventListener('change', this.start, true );
  }
  /**
   * Window event listener
   */
  windowEvent = () => {
      let timeoutId;
      // Avoid function being called twice on window resize
      window.addEventListener('resize', (e: Event) => {
          window.clearTimeout(timeoutId);
          timeoutId = window.setTimeout(() => {
              (this._mediaQuery) ? (this._mediaQuery.matches ? this.addEvent() : this.destroy()) : this.addEvent();
          }, this._resizeTimeOut);
      });        
  }
  /**
   * Resize
   * If we are in mobile verison then resize to landscape(for large device) or desktop
   */
  destroy = () => {
      this.close();
      this._triggerNav.checked = false;
      this.removeEvent();
  }
}

export default burgerNav;